// extracted by mini-css-extract-plugin
export default {"bgColor":"style_bgColor__0GcbU","loginWidth":"style_loginWidth__9TPd7","loginImage":"style_loginImage__9voD7","view":"style_view__omVbm"};